import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Convert snake_case string to Title Case
 * @param str - The snake_case string to convert
 * @returns The converted Title Case string
 */
export function snakeCaseToTitleCase(
  str: string | number | null | undefined
): string | number | null | undefined {
  if (!str || typeof str !== 'string') return str;

  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
